var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "workresultlistdiv1" },
    [
      _c("div", { staticClass: "title_h1" }, [_vm._v("作業報告書")]),
      _c(
        "vab-query-form",
        {
          ref: "queryForm",
          staticClass: "dpform DPR01G01",
          attrs: {
            model: _vm.queryForm,
            rules: _vm.rules,
            size: "mini",
            "label-width": "98px",
          },
          on: { search: _vm.fetchData, cancel: _vm.cancelSet },
        },
        [
          _c(
            "vab-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "vab-col",
                { attrs: { lg: 8, xl: 8, md: 12 } },
                [
                  _c("vab-date-picker", {
                    staticClass: "width_140",
                    attrs: {
                      type: "month",
                      label: "作業年月",
                      "value-format": "yyyyMM",
                      format: "yyyy/MM",
                      prop: "workYm",
                      validate: "required",
                      clearable: false,
                    },
                  }),
                ],
                1
              ),
              _c(
                "vab-col",
                { attrs: { lg: 8, xl: 8, md: 12 } },
                [
                  _c("vab-input", {
                    attrs: { label: "建物", prop: "blgsnmkj", maxlength: "62" },
                  }),
                ],
                1
              ),
              _c(
                "vab-col",
                { attrs: { lg: 8, xl: 8, md: 12 } },
                [
                  _c("vab-input", {
                    directives: [
                      {
                        name: "input",
                        rawName: "v-input.num_alp",
                        modifiers: { num_alp: true },
                      },
                    ],
                    attrs: {
                      label: "報告書No",
                      prop: "reportNo",
                      maxlength: "11",
                    },
                  }),
                ],
                1
              ),
              _c(
                "vab-col",
                { attrs: { lg: 8, xl: 8, md: 12 } },
                [
                  _c("MitmdtlpNew", {
                    attrs: {
                      componentcd: _vm.queryForm.itemDetailCdList,
                      prop: "itemDetailCdList",
                      "multi-select": false,
                      span1: 6,
                      span2: 18,
                    },
                    on: {
                      "update:componentcd": function ($event) {
                        return _vm.$set(
                          _vm.queryForm,
                          "itemDetailCdList",
                          $event
                        )
                      },
                      clearOtherData: _vm.clearOtherData,
                    },
                  }),
                ],
                1
              ),
              _c(
                "vab-col",
                { attrs: { lg: 8, xl: 8, md: 12 } },
                [
                  _c("vab-select", {
                    ref: "workSpecRef",
                    attrs: {
                      label: "点検仕様",
                      prop: "workSpecCdList",
                      "data-items": _vm.workSpecCdList,
                      "label-id": "itmgkmnm",
                      "value-id": "itmgkmcd",
                      "collapse-tags": "",
                      multiple: "",
                      disabled: _vm.workSpecCdListDisabled,
                      placeholder: "選択されていません",
                    },
                  }),
                ],
                1
              ),
              _c(
                "vab-col",
                {
                  staticClass: "label_height",
                  attrs: { lg: 8, xl: 8, md: 12 },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "big_label_110 label_height",
                      attrs: { label: "速報版提出期限日" },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { type: "flex" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c("vab-date-picker", {
                                staticClass: "date_box no_margin",
                                attrs: {
                                  type: "date",
                                  label: "速報版提出期限日",
                                  placeholder: "",
                                  "label-show": false,
                                  "value-format": "yyyy/MM/dd",
                                  format: "yyyy/MM/dd",
                                  prop: "preReportSubmintDeadlineFrom",
                                  "end-date-prop": "preReportSubmintDeadlineTo",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              staticClass: "line flex_center flex_center_align",
                              attrs: { span: 2 },
                            },
                            [_vm._v(" 〜 ")]
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c("vab-date-picker", {
                                staticClass: "date_box no_margin",
                                attrs: {
                                  type: "date",
                                  "label-show": false,
                                  "value-format": "yyyy/MM/dd",
                                  format: "yyyy/MM/dd",
                                  prop: "preReportSubmintDeadlineTo",
                                  "start-date-prop":
                                    "preReportSubmintDeadlineFrom",
                                  placeholder: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "vab-col",
                { attrs: { lg: 8, xl: 8, md: 12 } },
                [
                  _c("vab-select", {
                    ref: "preReportStatus",
                    staticClass: "label_height",
                    attrs: {
                      label: "速報版報告書状況",
                      prop: "preReportStatusList",
                      filter: "reportStatus",
                      clearable: "",
                      multiple: "",
                      "collapse-tags": "",
                      placeholder: "選択されていません",
                    },
                  }),
                ],
                1
              ),
              _c(
                "vab-col",
                {
                  staticClass: "label_height",
                  attrs: { lg: 8, xl: 8, md: 12 },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "big_label_110 label_height",
                      attrs: { label: "正式版提出期限日" },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { type: "flex" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c("vab-date-picker", {
                                staticClass: "date_box no_margin",
                                attrs: {
                                  type: "date",
                                  placeholder: "",
                                  "label-show": false,
                                  "value-format": "yyyy/MM/dd",
                                  format: "yyyy/MM/dd",
                                  prop: "officalReportSubmintDeadlineFrom",
                                  "end-date-prop":
                                    "officalReportSubmintDeadlineTo",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              staticClass: "line flex_center flex_center_align",
                              attrs: { span: 2 },
                            },
                            [_vm._v(" 〜 ")]
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c("vab-date-picker", {
                                staticClass: "date_box no_margin",
                                attrs: {
                                  type: "date",
                                  "label-show": false,
                                  "value-format": "yyyy/MM/dd",
                                  format: "yyyy/MM/dd",
                                  prop: "officalReportSubmintDeadlineTo",
                                  "start-date-prop":
                                    "officalReportSubmintDeadlineFrom",
                                  placeholder: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "vab-col",
                { attrs: { lg: 8, xl: 8, md: 12 } },
                [
                  _c("vab-select", {
                    ref: "officalReportStatus",
                    staticClass: "label_height",
                    attrs: {
                      label: "正式版報告書状況",
                      prop: "officalReportStatusList",
                      filter: "reportStatus",
                      clearable: "",
                      multiple: "",
                      "collapse-tags": "",
                      placeholder: "選択されていません",
                    },
                  }),
                ],
                1
              ),
              _c(
                "vab-collapse",
                { attrs: { title: "詳細検索を表示" } },
                [
                  _c(
                    "vab-col",
                    { attrs: { lg: 8, xl: 8, md: 12 } },
                    [
                      _c("vab-select", {
                        ref: "workFinishSelect",
                        attrs: {
                          label: "作業完了状況",
                          prop: "workFinishClassList",
                          filter: "finishFlg",
                          clearable: "",
                          multiple: "",
                          "collapse-tags": "",
                          placeholder: "選択されていません",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "vab-col",
                    { attrs: { lg: 8, xl: 8, md: 12 } },
                    [
                      _c("vab-select", {
                        attrs: {
                          label: "不具合有無",
                          prop: "defectCustomList",
                          filter: "existFlag2",
                          clearable: "",
                          multiple: "",
                          "collapse-tags": "",
                          placeholder: "選択されていません",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vab-form",
        { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c("vab-table", {
                    ref: "table",
                    staticClass: "vab_table vab_report_table",
                    attrs: {
                      "api-url": "/api/workingPlanAndResult/query-list-kr",
                      columns: _vm.columns,
                      "nav-buttons": _vm.navButtons,
                      "enable-init": _vm.reloadPage,
                      "query-params": Object.assign(
                        {},
                        _vm.setQueryParams(_vm.queryForm),
                        {
                          sidx: "workNo,workingPlanAndResultId",
                          sort: "desc,desc",
                        }
                      ),
                      "init-params": Object.assign(
                        {},
                        _vm.setQueryParams(_vm.queryForm),
                        {
                          sidx: "workNo,workingPlanAndResultId",
                          sort: "desc,desc",
                        }
                      ),
                      "primary-key": "workingPlanAndResultId",
                      "row-class-name": function (ref) {
                        var row = ref.row
                        var rowIndex = ref.rowIndex

                        return _vm.rowClassName(
                          row,
                          rowIndex,
                          "workNo",
                          _vm.selectRows
                        )
                      },
                    },
                    on: {
                      select: _vm.setSelectRows,
                      "select-all": _vm.handleSelectAll,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }